import { useState } from "react";
import HeaderWithoutLogin from "../components/HeaderWithoutLogin";
import SendEmail from "../components/ForgotPasswordComponents/SendEmail";
import PasswordChangeConfirmation from "../components/ForgotPasswordComponents/PasswordChangeConfirmation";
import EnterVerificationCode from "../components/ForgotPasswordComponents/EnterVerificationCode";
import Card from "../components/Card/Card";
import styled from "styled-components";

const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .formContainer {
    max-width: 500px;
    width: 100%;
    margin-top: 3%;
  }

  .buttonContainer {
    width: 100%;
    max-width: 800px;
    text-align: right;
    margin-top: 15px;
  }
`;

const ForgotPassword = () => {
  const [mailId, setMailId] = useState("");
  const [
    isPasswordChangeSuccessfullVisible,
    setIsPasswordChangeSuccessfullVisible,
  ] = useState(false);

  const handleMailSent = (mailId) => {
    setMailId(mailId);
  };

  const handlePasswordChangeSuccessful = () => {
    setIsPasswordChangeSuccessfullVisible(true);
  };
  return (
    <>
      <HeaderWithoutLogin isLogOutButtonVisible={false} />
      <BodyWrapper>
        <div className="formContainer">
          <Card>
            {!mailId ? (
              <SendEmail mailSendSuccessfull={handleMailSent} />
            ) : isPasswordChangeSuccessfullVisible ? (
              <PasswordChangeConfirmation />
            ) : (
              <EnterVerificationCode
                mailId={mailId}
                passwordChangeSuccessful={handlePasswordChangeSuccessful}
              />
            )}
          </Card>
        </div>
      </BodyWrapper>
    </>
  );
};

export default ForgotPassword;
